import type { CancelToken } from 'axios';
import Axios from 'axios';
import { sleep } from './timing';

export interface CooldownOptions {
  minimum?: number;
  multiplier?: number;
  /**
   * TODO: Remove this when we've ported everything to Node 18, including the
   * version of Kelda that Nan is using for testing.
   */
  performanceNow: () => number;
}

export async function repeatWithCooldown(action: (ct: CancelToken) => Promise<void>, cooldownOptions: CooldownOptions, ct: CancelToken) {
  // By default, have at least 5 seconds of idle time between actions.
  const minimum = cooldownOptions.minimum ?? 5000;

  /*
    By default, spend at a maximum 20% of the elapsed time performing the
    operation.
  */
  const multiplier = cooldownOptions.multiplier ?? 4;

  while (true) {
    ct.throwIfRequested();
    const before = cooldownOptions.performanceNow();
    await action(ct);
    const elapsed = cooldownOptions.performanceNow() - before;
    const cooldown = Math.max(minimum, elapsed * multiplier);
    await sleep(cooldown, ct);
  }
}

function rethrowIfNotCancelled(err: any) {
  if (!Axios.isCancel(err))
    throw err;
}

export async function repeatWithCooldownUntilCancelled(action: (ct: CancelToken) => Promise<void>, cooldownOptions: CooldownOptions, ct: CancelToken) {
  await repeatWithCooldown(action, cooldownOptions, ct).catch(rethrowIfNotCancelled);
}

